module.exports = __webpack_public_path__ + "img/ljts.fbb37961.png";